import type { DestinationMetadata } from '@/scopes/search/quick-search/domain/types'
import type { FilterOption } from '@/scopes/search/types'
import { useIntl } from '@/intl'
import { PartiallyHighlightedText } from '@/scopes/search/components/PartiallyHighlightedText'
import { Button, tk, Typography } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  ${Typography} {
    ${Typography.modVariant('body-md-bold')}
    text-align: left;
  }
`

const Subtitle = styled(Typography)``

const Btn = styled(Button)`
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: baseline;
  padding: ${tk('spacing_xs')} ${tk('spacing_md')};
  text-align: left;

  border-radius: 0;
  min-height: initial;

  width: 100%;

  &:hover {
    background-color: ${tk('color_semantic_bg_subdued_hover')};
    border-radius: 6px;
  }

  ${Subtitle} {
    margin: 0;
    ${Typography.modVariant('label-thin')}
  }
`

const StyledPartiallyHighlightedText = styled(PartiallyHighlightedText)`
  text-align: justify;
  margin-right: 0;
`

export function Destination({
  option,
  onItemClick,
  query,
}: {
  option: FilterOption<string, DestinationMetadata>
  onItemClick: (selection: FilterOption<string, DestinationMetadata>) => void
  query: string
}) {
  const intl = useIntl()
  return (
    <Btn key={option.value} $hierarchy="tertiary" $withoutColor onClick={() => onItemClick(option)}>
      <Wrapper>
        <StyledPartiallyHighlightedText text={option.name} query={query} />
        <Typography>{option.resultsCount}</Typography>
      </Wrapper>
      {option.metadata?.parentName && option.metadata.type === 'Region' && (
        <Subtitle>
          {intl.formatMessage(
            { id: 'quicksearch_filter_destination_region_subtitle' },
            { country_name: option.metadata.parentName },
          )}
        </Subtitle>
      )}
      {option.metadata?.parentName && option.metadata.type === 'City' && (
        <Subtitle>
          {intl.formatMessage(
            { id: 'quicksearch_filter_destination_city_subtitle' },
            { region_name: option.metadata.parentName },
          )}
        </Subtitle>
      )}
    </Btn>
  )
}
